<template>
	<div>
		<v-app>
			<v-overlay :value="attempting" z-index="1000">
				<v-progress-circular
				indeterminate
				size="100"
				></v-progress-circular>
			</v-overlay>
			<v-navigation-drawer v-model="drawer" color="white" app floating :width="navbar" class="nav-shadow">
				<v-list color="white" light>
					<v-list-item>
						<v-list-item-action>
							<v-icon>mdi-warehouse</v-icon>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>{{ userData.warehouse_name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
				<v-list dense class="pt-0 cus-m-navbar">
					<div v-for="menu in userData.user_privilege" :key="menu.menu_id">
						<v-list-group  no-action color="purple darken-4" v-if="menu.menu_array">
							<v-icon slot="prependIcon">{{ menu.menu_icon }}</v-icon>
							<template v-slot:activator>
								<v-tooltip bottom v-if="menu.menu_name.length >= 16">
									<template v-slot:activator="{ on, attrs }">
										<v-list-item-content v-bind="attrs" v-on="on">
											<v-list-item-title>{{ menu.menu_name }}</v-list-item-title>
										</v-list-item-content>
									</template>
									<span>{{ menu.menu_name }}</span>
								</v-tooltip>
								<v-list-item-content v-else>
									<v-list-item-title>{{ menu.menu_name }}</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item v-for="submenu in menu.menu_array" :key="submenu.menu_id" router :to="submenu.menu_end_point">
								<v-tooltip bottom v-if="submenu.menu_name.length >= 28">
									<template v-slot:activator="{ on, attrs }">
										<v-list-item-content v-bind="attrs" v-on="on">
											<v-list-item-title>
												<span v-if="navbar == 60" class="collapse-icon">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
														</template>
														<span>{{ submenu.menu_name }}</span>
													</v-tooltip>
												</span>
												<span v-else>{{ submenu.menu_name }}</span>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<span>{{ submenu.menu_name }}</span>
								</v-tooltip>
								<v-list-item-content v-else>
									<v-list-item-title>
										<span v-if="navbar == 60" class="collapse-icon">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-icon v-bind="attrs" v-on="on">mdi-chevron-right</v-icon>
												</template>
												<span>{{ submenu.menu_name }}</span>
											</v-tooltip>
										</span>
										<span v-else>{{ submenu.menu_name }}</span>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
						<div v-else>
							<v-tooltip bottom v-if="menu.menu_name.length > 16">
								<template v-slot:activator="{ on, attrs }">
									<v-list-item link router :to="menu.menu_end_point" color="purple darken-4" v-bind="attrs" v-on="on">
										<v-list-item-action>
											<!-- <span v-if="navbar == 60">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-icon v-bind="attrs" v-on="on">{{menu.menu_icon}}</v-icon>
													</template>
													<span>{{ menu.menu_name }}</span>
												</v-tooltip>
											</span> -->
											<span><v-icon>{{menu.menu_icon}}</v-icon></span>
										</v-list-item-action>
										<v-list-item-content>
											<v-list-item-title>
												<span >{{ menu.menu_name }}</span>
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
								<span>{{ menu.menu_name }}</span>
							</v-tooltip>
							<v-list-item link router :to="menu.menu_end_point" color="purple darken-4" v-else>
								<v-list-item-action>
									<!-- <span v-if="navbar == 60">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on">{{menu.menu_icon}}</v-icon>
											</template>
											<span>{{ menu.menu_name }}</span>
										</v-tooltip>
									</span> -->
									<span>
										<v-icon>{{menu.menu_icon}}</v-icon>
									</span>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>{{menu.menu_name}}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</div>
					</div>
				</v-list>
			</v-navigation-drawer>

			<toolbar v-on:childToParent="clickDrawer" />

			<v-main>
				<v-container class="" fluid>
					<v-row align="center" justify="center">
						<v-col class="pl-5 pr-5">
							<v-snackbar v-model="snackbar.show" timeout="2000" right top :color="snackbar.color">
								{{snackbar.text}}
								<template v-slot:action="{ attrs }">
									<v-btn color="white" text v-bind="attrs" @click="hideSnackbar">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</template>
							</v-snackbar>
							<router-view />
						</v-col>
					</v-row>
				</v-container>
			</v-main>
		</v-app>
	</div>
</template>

<script>
import toolbar from '@/components/Toolbar';
import { mapState, mapMutations } from 'vuex'

export default {
	components: {
		toolbar
	},
	props: {
		source: String,
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState(['snackbar', 'attempting']),
	},
	data: () => ({
		drawer: null,
		navbar: 256,
	}),
	methods: {
		...mapMutations(['hideSnackbar']),

		clickDrawer() {
			if (window.matchMedia('(min-width: 1264px)').matches) {
				if (this.navbar == 256) {
					this.navbar = 60
				} else {
					this.navbar = 256
				}
			} else {
				this.drawer = !this.drawer
			}
		},
	}
}
</script>